import React, { FC, memo } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { Box, Typography } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { SavedLanesCTAIcon } from './SavedLanesCTAIcon'
import { useSavedLanesCTAStyles } from './useSavedLanesCTAStyles'

export const SavedLanesCTA: FC = memo(() => {
  const classes = useSavedLanesCTAStyles()
  const history = useHistory()
  const { isMobile } = useBreakpointContext()
  const addLaneClickHandler = () => {
    history.push('/transfix-lanes/add-alert')
  }

  return (
    <Box
      data-test='saved-lanes-cta'
      display='flex'
      flexDirection='row'
      className={classes.root}
      justifyContent='space-between'>
      <Box display='flex' flexDirection='column' alignItems='flex-start'>
        <Typography variant='h3' className={classes.text}>
          Saved Lanes
        </Typography>
        <Typography variant='body1' className={classes.text}>
          Get the most personalized load recommendations when you add saved lanes.
        </Typography>
        <Button
          className={classes.button}
          onClick={addLaneClickHandler}
          data-test='saved-lanes-cta-button'>
          Add New Lane
        </Button>
      </Box>
      {!isMobile && (
        <Box display='flex' flexDirection='column' alignItems='flex-end'>
          <SavedLanesCTAIcon />
        </Box>
      )}
    </Box>
  )
})

export default SavedLanesCTA
